var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-1 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Free-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "#0a19ee",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-896.000000, -378.000000)",
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(893.000000, 376.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.77777778,21 C4.79593822,21 4,20.0050772 4,18.7777778 L4,5.22222222 C4,3.99492278 4.79593822,3 5.77777778,3 L8.22222222,3 C9.20406178,3 10,3.99492278 10,5.22222222 L10,18.7777778 C10,20.0050772 9.20406178,21 8.22222222,21 L5.77777778,21 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,5.22222222 C14,3.99492278 14.7959382,3 15.7777778,3 L18.2222222,3 C19.2040618,3 20,3.99492278 20,5.22222222 L20,18.7777778 C20,20.0050772 19.2040618,21 18.2222222,21 L15.7777778,21 C14.7959382,21 14,20.0050772 14,18.7777778 L14,5.22222222 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/pause-icon.2f59dcb30046a9933e526a6cd3d19ccc.svg";
export { ForwardRef as ReactComponent };